import WillGuard from './abi/WillGuard.json';

// Environment variables with fallbacks (Create React App style)
export const CONFIG = {
  // Contract Configuration
  CONTRACT_ADDRESS: process.env.REACT_APP_CONTRACT_ADDRESS || "0x33fbA290d4a3e2D73FC44b497201DD60D2dd130d",
  CONTRACT_ADDRESS_V2: process.env.REACT_APP_CONTRACT_ADDRESS_V2 || "",
  CONTRACT_ABI: WillGuard.abi,
  
  // Pinata Configuration
  PINATA_API_KEY: process.env.REACT_APP_PINATA_API_KEY || "",
  PINATA_SECRET_KEY: process.env.REACT_APP_PINATA_SECRET_KEY || "",
  
  // Network Configuration
  NETWORK_ID: process.env.REACT_APP_NETWORK_ID || "5777",
  NETWORK_NAME: process.env.REACT_APP_NETWORK_NAME || "Ganache",
  RPC_URL: process.env.REACT_APP_RPC_URL || "http://localhost:7545",
  
  // Application Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || "WillGuard",
  APP_VERSION: process.env.REACT_APP_APP_VERSION || "1.0.0",
  APP_DESCRIPTION: process.env.REACT_APP_APP_DESCRIPTION || "Decentralized Digital Will Registry",
  
  // Feature Flags
  ENABLE_NOTIFICATIONS: process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true',
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  
  // Default Values
  DEFAULT_HEARTBEAT_INTERVAL: 86400, // 24 hours in seconds
  DEFAULT_QUORUM: 1,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  SUPPORTED_FILE_TYPES: ['pdf', 'doc', 'docx', 'txt', 'jpg', 'png', 'jpeg']
};

// Validation
export const validateConfig = () => {
  const missing = [];
  const warnings = [];
  
  // Critical validations
  if (!CONFIG.PINATA_API_KEY) missing.push('VITE_PINATA_API_KEY');
  if (!CONFIG.PINATA_SECRET_KEY) missing.push('VITE_PINATA_SECRET_KEY');
  if (!CONFIG.CONTRACT_ADDRESS) missing.push('VITE_CONTRACT_ADDRESS');
  
  // Warning validations
  if (!CONFIG.CONTRACT_ADDRESS_V2) warnings.push('VITE_CONTRACT_ADDRESS_V2 (optional)');
  
  if (missing.length > 0) {
    console.error('❌ Missing critical environment variables:', missing.join(', '));
    console.error('Please check your .env file and ensure all required variables are set.');
    return false;
  }
  
  if (warnings.length > 0) {
    console.warn('⚠️ Missing optional environment variables:', warnings.join(', '));
  }
  
  if (CONFIG.ENABLE_DEBUG) {
    console.log('✅ Configuration loaded successfully:', {
      contractAddress: CONFIG.CONTRACT_ADDRESS,
      networkName: CONFIG.NETWORK_NAME,
      appName: CONFIG.APP_NAME,
      version: CONFIG.APP_VERSION
    });
  }
  
  return true;
};

// Helper functions
export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => process.env.NODE_ENV === 'production';

export const getNetworkConfig = () => ({
  chainId: parseInt(CONFIG.NETWORK_ID),
  chainName: CONFIG.NETWORK_NAME,
  rpcUrls: [CONFIG.RPC_URL],
  blockExplorerUrls: CONFIG.NETWORK_NAME === 'Ganache' ? [] : [`https://${CONFIG.NETWORK_NAME.toLowerCase()}.etherscan.io`]
});

// Legacy exports for backward compatibility
export const CONTRACT_ADDRESS = CONFIG.CONTRACT_ADDRESS;
export const NETWORK_ID = CONFIG.NETWORK_ID;
